import './Nav.css';



function Nav() {
  return (
<header className="header">
    <div className="logo">
    <h1>REMEMBERING AYURVEDA</h1>
        <p className="sub-heading">Small steps into deep healing. Remembering your true nature.</p>
    </div>
     <nav className="nav">
        <a href="#work-with-me">Offerings</a>
        <a href="#about">About</a>    
        <a href="#connect">Connect</a>    
      </nav>
</header>

  );
}

export default Nav;